export default __webpack_public_path__ + "static/media/Profile_icon_black.ceaa0223.svg";